import { PropsWithChildren, ReactElement } from "react";

type RadioButtonProps = {
  name?: string;
  id?: string;
  checked: boolean;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  label: string | ReactElement;
  disabled?: boolean;
  noBg?: boolean;
  dataTestId?: string;
  bgOverflow?: boolean;
};

export function RadioButton(props: RadioButtonProps): JSX.Element {
  return (
    <div
      className={
        props.bgOverflow
          ? `px-4 ${props.checked ? "bg-ldir-blue-paler" : props.noBg ? "" : "bg-ldir-gray-600"}`
          : ""
      }
    >
      <label
        htmlFor={props.id}
        className={`${props.noBg ? "" : "formLabel"} ${
          props.checked ? "bg-ldir-blue-paler" : props.noBg ? "" : "bg-ldir-gray-600"
        } w-full py-4 border-t  border-ldir-blue-pale flex flex-row items-center hover:cursor-pointer`}
      >
        <input
          type="radio"
          onChange={props.onChange}
          data-testid={props.dataTestId}
          checked={props.checked}
          name={props.name}
          id={props.id}
          disabled={props.disabled}
          className="sr-only peer"
        />
        <RadioButtonUnchecked />
        <RadioButtonChecked />
        <span className="text-xl">{props.label}</span>
      </label>
    </div>
  );
}

export function RadioGroup({ children }: PropsWithChildren): JSX.Element {
  return <div className="flex flex-col text-ldir-brown-900">{children}</div>;
}

const radioButtonSvgStyle = " ml-3.5 mr-6 rounded-full outline-offset-1";

export function RadioButtonUnchecked() {
  return (
    <svg
      className={`w-8 h-8 shrink-0 peer-checked:hidden ${radioButtonSvgStyle}`}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      fill="none"
      aria-hidden
      aria-label="radio"
      role="graphics-symbol"
    >
      <circle cx="16" cy="16" r="14" stroke="#37261D" strokeWidth="4" fill="none" />
    </svg>
  );
}

export function RadioButtonChecked() {
  return (
    <svg
      className={"w-8 h-8 shrink-0 hidden peer-checked:block" + radioButtonSvgStyle}
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      aria-hidden
    >
      <title>valgt</title>
      <path
        d="M16 24C18.2133 24 20.1 23.22 21.66 21.66C23.22 20.1 24 18.2133 24 16C24 13.7867 23.22 11.9 21.66 10.34C20.1 8.78 18.2133 8 16 8C13.7867 8 11.9 8.78 10.34 10.34C8.78 11.9 8 13.7867 8 16C8 18.2133 8.78 20.1 10.34 21.66C11.9 23.22 13.7867 24 16 24ZM16 32C13.7867 32 11.7067 31.58 9.76 30.74C7.81333 29.9 6.12 28.76 4.68 27.32C3.24 25.88 2.1 24.1867 1.26 22.24C0.42 20.2933 0 18.2133 0 16C0 13.7867 0.42 11.7067 1.26 9.76C2.1 7.81333 3.24 6.12 4.68 4.68C6.12 3.24 7.81333 2.1 9.76 1.26C11.7067 0.42 13.7867 0 16 0C18.2133 0 20.2933 0.42 22.24 1.26C24.1867 2.1 25.88 3.24 27.32 4.68C28.76 6.12 29.9 7.81333 30.74 9.76C31.58 11.7067 32 13.7867 32 16C32 18.2133 31.58 20.2933 30.74 22.24C29.9 24.1867 28.76 25.88 27.32 27.32C25.88 28.76 24.1867 29.9 22.24 30.74C20.2933 31.58 18.2133 32 16 32ZM16 28.8C19.5733 28.8 22.6 27.56 25.08 25.08C27.56 22.6 28.8 19.5733 28.8 16C28.8 12.4267 27.56 9.4 25.08 6.92C22.6 4.44 19.5733 3.2 16 3.2C12.4267 3.2 9.4 4.44 6.92 6.92C4.44 9.4 3.2 12.4267 3.2 16C3.2 19.5733 4.44 22.6 6.92 25.08C9.4 27.56 12.4267 28.8 16 28.8Z"
        fill="#006178"
      />
    </svg>
  );
}
